import type { GmUserProfileInfoProps } from './types';
import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import { useMediaQuery } from '@/hooks/useMediaQuery';
import { playerQueryOptions } from '@/queries/player/player.queries';
import { useUserMeQuery } from '@/queries/user/user.queries';
import { useAppSelector } from '@/redux/hooks';
import { getStatusImagePath } from '../../model/utils/getProgressStatusAssetMedia';
import { GmUserProfileDesktop } from './components/GmUserProfileDesktop';
import { GmUserProfileMobile } from './components/GmUserProfileMobile';

export const GmUserProfileInfo = ({ open, onOpenChange }: GmUserProfileInfoProps) => {
  const isMobile = useMediaQuery('(max-width: 1024px)');
  const [uncontrolledOpen, setUncontrolledOpen] = useState(false);

  const isOpen = open ?? uncontrolledOpen;
  const setIsOpen = onOpenChange ?? setUncontrolledOpen;

  const { data: user } = useUserMeQuery();
  const userSession = useAppSelector(state => state.user.userSession);

  const { data: playerProfile } = useQuery(playerQueryOptions.mePlayerProfile({ enabled: !!userSession }));

  const progressStatus = playerProfile?.progressStatus;
  const statusName = progressStatus?.name || '';
  const statusImageSrc = progressStatus ? getStatusImagePath(progressStatus) : undefined;

  const viewProps = {
    isOpen,
    onOpenChange: setIsOpen,
    statusName,
    statusImageSrc,
    user,
  };

  if (isMobile) {
    return <GmUserProfileMobile {...viewProps} />;
  }

  return <GmUserProfileDesktop {...viewProps} />;
};
